/**
 * @description
 *
 * @sort "rut"
 * @sort "business_name"
 * @sort "alias_name"
 * @sort "address"
 */
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'rut',
        value: 'rut',
        sortable: true,
        format: 'rut',
        width: '200px',
    },
    {
        text: 'razón social',
        value: 'business_name',
        sortable: true,
    },
    {
        text: 'nombre',
        value: 'alias_name',
        sortable: true,
    },
    {
        text: 'sucursales',
        value: 'pch_provider_branch_offices_address',
        sortable: 'address',
        component: {
            type: 'chip-list',
        },
    },
    {
        text: 'creación',
        value: 'created_at',
        align: 'right',
        format: 'datetime',
    },
]
